import questionType from "./questionType";
export default {
  namespaced: true,
  state: {},
  actions: {
    // 添加问卷题目
    addQuestion({}, type) {
      const queston_type = questionType.state.queston_type;
      switch (type) {
        case queston_type.SCQ:
          return {
            type: queston_type.SCQ,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  jump_title: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.MCQ:
          return {
            type: queston_type.MCQ,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              maxCount: 2,
              minCount: 1,
              isCountMust: 0,
              isCountSwitch: 0,
            }),
            status: "0",
          };
        case queston_type.SBQ:
          return {
            type: queston_type.SBQ,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            fillSymbol: 3, // 填空符数量
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            status: "0",
          };
        case queston_type.MBQ:
          return {
            type: queston_type.MBQ, // 分数评定类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  img_path: [],
                },
                {
                  text: "",
                  img_path: [],
                },
                {
                  text: "",
                  img_path: [],
                },
              ],
            }),
            status: "0",
          };
        case queston_type.DLQ:
          return {
            type: queston_type.DLQ, // 下拉类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                },
                {
                  text: "",
                },
                {
                  text: "",
                },
              ],
              value: "",
            }),
            status: "0",
          };
        case queston_type.NPS:
          return {
            type: queston_type.NPS, // NPS类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.VOTE:
          return {
            type: queston_type.VOTE, // 投票类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            ifShowResult: 0, // 0 不展示 1 展示
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
			  maxCount: 2,
			  minCount: 1,
			  isCountMust: 0,
			  isCountSwitch: 0,
            }),
            status: "0",
          };
        case queston_type.SORT:
          return {
            type: queston_type.SORT, // 排序类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: true,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 3, //统一格式的话 有几项就得填几项 前端决定
            }),
            status: "0",
          };
        case queston_type.REMARK:
          return {
            type: queston_type.REMARK, // 备注类型
            caseProblem: "",
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.SCORE:
          return {
            type: queston_type.SCORE, // 分数评定类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            minScore: 1, // 起始分数
            scoreNum: 5, // 评分数量
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意", "一般", "非常满意"],
                },
              ],
            }),
            status: "0",
          };
        case queston_type.QA:
          return {
            type: queston_type.QA, // 问答题
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.WRQ:
          return {
            type: queston_type.WRQ, // 权重评分类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
              ],
            }),
            status: "0",
          };
        case queston_type.SRQ:
          return {
            type: queston_type.SRQ, // 评星类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            scoreNum: 5, // 最高分
            starRatingStyle: "1", // 评星样式 前端定 字符串类型
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意", "一般", "非常满意"],
                },
              ],
            }),
            status: "0",
          };
        case queston_type.NAME:
          return {
            type: queston_type.NAME, // 姓名
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.GENDER:
          return {
            type: queston_type.GENDER, // 性别
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "男",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "女",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          };
        case queston_type.AGE:
          return {
            type: queston_type.AGE, // 年龄
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "18岁以下",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "18~35岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "35~60岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "60岁以上",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          };
        case queston_type.TEL:
          return {
            type: queston_type.TEL, // 手机号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            isOnly: 0, // 0 是否唯一  0否 1是
            status: "0",
          };
        case queston_type.EMAIL:
          return {
            type: queston_type.EMAIL, // 邮箱
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.DATE:
          return {
            type: queston_type.DATE, // 日期
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.TIME:
          return {
            type: queston_type.TIME, // 时间
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.ADDR:
          return {
            type: queston_type.ADDR, // 地址类型
            caseProblem: "", // 题目
            mapAccuracy: 3, // 0 选择地址精度 1 精确到省 2 精确到市 3 精确到区 4 精确到详细地址
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            status: "0",
          };
        case queston_type.IMAGE:
          return {
            type: queston_type.IMAGE, // 图片上传类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            pictureNum: 6, // 图片数量
            status: "0",
          };
        case queston_type.MaxDiff:
          return {
            type: queston_type.MaxDiff,
            caseProblem: "请输入题目说明",
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({
              list: [
                {
                  id: "1",
                  context: "属性1",
                },
                {
                  id: "2",
                  context: "属性2",
                },
                {
                  id: "3",
                  context: "属性3",
                },
              ],
              tasksNum: 6,
              attributesNum: 3,
              percentageTitle: "满意,不满意",
              count: 1,
            }),
            status: "0",
          };
        case queston_type.UploadFile:
          return {
            type: queston_type.UploadFile,
            caseProblem: "请上传文件",
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            status: "0",
          };
        case queston_type.DownloadFile:
          return {
            type: queston_type.DownloadFile,
            caseProblem: "请输入题目说明",
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({ list: [] }),
            status: "0",
          };
        case queston_type.CASCADER:
          return {
            type: queston_type.CASCADER,
            caseProblem: "请输入题目说明",
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({
              options: [
                {
                  label: "一级选项",
                  children: [
                    {
                      label: "二级选项1",
                      children: [],
                    },
                  ],
                },
              ],
            }),
            elseConfig: "一级标题名称,二级标题名称",
            status: "0",
          };
        case queston_type.BDQ:
          return {
            type: queston_type.BDQ, // 出生日期
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.IDQ:
          return {
            type: queston_type.IDQ, // 身份证号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.ELQ:
          return {
            type: queston_type.ELQ, // 学历
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "初中及以下",
                },
                {
                  text: "高中/中专/技校",
                },
                {
                  text: "大学专科",
                },
                {
                  text: "大学本科",
                },
                {
                  text: "硕士及以上",
                },
              ],
            }),
            status: "0",
          };
        case queston_type.WX:
          return {
            type: queston_type.WX, // 微信号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          };
        case queston_type.TITLE:
          return {
            type: queston_type.TITLE, // 标题
            caseProblem: "", // 题目
            status: "0",
          };
        case queston_type.ImageSCQ:
          return {
            type: queston_type.ImageSCQ,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "", // 名称
                  context: "", // 说明
                  isChoose: false, // 是否选择
                  img_path: "", // 图片地址
                },
                {
                  text: "", // 名称
                  context: "", // 说明
                  isChoose: false, // 是否选择
                  img_path: "", // 图片地址
                },
              ],
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.ImageMCQ:
          return {
            type: queston_type.ImageMCQ,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "", // 名称
                  context: "", // 说明
                  isChoose: false, // 是否选择
                  img_path: "", // 图片地址
                },
                {
                  text: "", // 名称
                  context: "", // 说明
                  isChoose: false, // 是否选择
                  img_path: "", // 图片地址
                },
              ],
              maxCount: 2,
              minCount: 1,
              isCountMust: 0,
              isCountSwitch: 0,
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.MatrixSCQ:
          return {
            type: queston_type.MatrixSCQ,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  id: "", //选项ID
                  context: "",
                },
                {
                  id: "", //选项ID
                  context: "",
                },
                {
                  id: "", //选项ID
                  context: "",
                },
              ],
              verticalNum: 3, //竖列 2-3
              // 满意,不满意,中立
              percentageTitle: "", //竖列标题
              // 横标题
              horizontalTitle: "",
            }),
            isMust: 1, // 是否必填  0否 1是
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.MatrixMCQ:
          return {
            type: queston_type.MatrixMCQ,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  id: "", //选项ID
                  context: "",
                },
                {
                  id: "", //选项ID
                  context: "",
                },
                {
                  id: "", //选项ID
                  context: "",
                },
              ],
              verticalNum: 3, //竖列 2-3
              // 满意,不满意,中立
              percentageTitle: "", //竖列标题
              // 横标题
              horizontalTitle: "",
            }),
            isMust: 1, // 是否必填  0否 1是
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          };
        case queston_type.ImageOrVideo:
          // 图片/视频
          return {
            type: queston_type.ImageOrVideo, // 图片/视频
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            chooseList: JSON.stringify({
              list: [
                {
                  url: "", // 图片/视频地址
                  type: "",
                },
              ],
            }),
            isMust: 1, // 是否必填  0否 1是
            status: "0",
          };
        case queston_type.Signature:
          // 签名题
          return {
            type: queston_type.Signature, // 签名题
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            status: "0",
          };
        case queston_type.PageBreak:
          return {};
        default:
          return {};
      }
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/moduleQuestionnaire.js